<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="md-grey-page website-edit">
		<div class="edit-page container margin-top-60 text-center" v-if="!loaded">
			<p class="loading-text">Loading website settings<span>.</span><span>.</span><span>.</span></p>
		</div>
		<div class="edit-page container" v-if="loaded">
			<h2 class="text-center">Website Settings</h2>
		  	<div class="mdc-layout-grid">
				<div class="mdc-layout-grid__inner edit-page__inner">
					<div class="edit-page__content mdc-layout-grid__cell mdc-layout-grid__cell--span-12">

						<!-- URL -->
						<div class="editable-item mdc-layout-grid__inner website-edit__custom-domain">
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-tablet editable-item__title">
								<div class="editable-item__centered"><span>Your website address</span></div>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-4-tablet website-edit__custom-domain__body">
								<div class="font-smaller">
									Here is your website's url:
								</div>
								<div class="width-100 website-edit__custom-domain__url-wrapper">
									<a class="website-edit__custom-domain__url" :href="website.siteUrl" target="_blank">{{website.siteUrl}}</a>
								</div>
								<div class="width-100 font-smaller">
									Select one of the options if you want a custom domain:
								</div>
								<div class="margin-top-30 website-edit__custom-domain-btn">
									<a href="#" class="mdc-button mdc-button--raised purple-background" @click.prevent="ownDomainDialog = true">I already have a domain I want to use</a>
								</div>
								<div class="margin-top-30 website-edit__custom-domain-btn">
									<a href="#" class="mdc-button mdc-button--raised yellow-background" @click.prevent="newDomainDialog = true">I'd like to buy a new domain name</a>
								</div>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>

							<!-- Own Domain dialog -->
							<aside id="own-domain-dialog" class="mdc-dialog website-edit__custom-domain-dialog text-left" :class="{'mdc-dialog--open': ownDomainDialog}" role="alertdialog" aria-hidden="true" aria-labelledby="mdc-dialog-default-label" aria-describedby="mdc-dialog-default-description">
								<div class="mdc-dialog__surface">
								<header class="mdc-dialog__header">
									<h3 class="mdc-dialog__header__title" v-if="!changeDomainSuccess">Please follow these steps:</h3>
									<h3 class="mdc-dialog__header__title success-message" v-if="changeDomainSuccess">Done!</h3>
								</header>
								<section class="mdc-dialog__body mdc-dialog__body--scrollable" v-if="!changeDomainComplete">
									<ul class="mdc-list">
										<li>
											<span class="list-number">1. </span>Enter your domain:
											<div class="width-100 mdc-textfield mdc-textfield--upgraded">
												<input class="mdc-textfield__input" type="text" v-model="newChangeDomain">
												<span class="input--spinner btn--spinner" :class="{'btn-spin--visible': domainSpinner}"></span>
											</div>
										</li>
										<li class="margin-top-30"><span class="list-number">2. </span>Log into your DNS provider panel or console.</li>
										<li class="margin-top-30"><span class="list-number">3. </span>Navigate to your DNS Management page. The location and name of this page vary by provider, but it can be found under Domain Management or Advanced Settings and then select the domain name that you want to update.</li>
										<li class="margin-top-30"><span class="list-number">4. </span>Locate the Records section. Choose to create an A Record from the drop-down list and then complete the below fields:
											<ul>
												<li><b>Host / Name</b> (subdomain i.e. first part of your domain before the first dot)</li>
												<li><b>Value</b>: 138.68.181.70</li>
												<li><b>TTL</b> (‘Time To Live’ is a propagation time.  The value should be lowest i.e. 1 minute or leave this option default as per your registrar).Click the Save Changes button to apply the changes.</li>
											</ul>
										</li>
										<li class="margin-top-30"><span class="list-number">5. </span>Click the Save button to apply the changes.</li>
									</ul>
								</section>
								<section class="mdc-dialog__body mdc-dialog__body--scrollable" v-if="changeDomainComplete">
									<h3 v-if="changeDomainSuccess">
										Thank you, as soon as your DNS changes to your domain propagated you'll be able to access your website using <a :href="website.siteUrl" class="website-edit__custom-domain--bold">{{website.siteUrl}}</a>.
									</h3>
									<h3 v-if="!changeDomainSuccess">
										Sorry, an error ocurred while changing your domain.
									</h3>
								</section>
								<footer class="mdc-dialog__footer" v-if="!changeDomainComplete">
									<button type="button" @click.prevent="ownDomainDialog = false" class="mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel mdc-ripple-upgraded">CANCEL</button>
									<button-with-spinner :isSaving="isChangingDomain" :text="isChangingDomain ? 'Changing domain...' : 'SAVE'" :customMethod="changeDomain" :disabled="isChangingDomain"></button-with-spinner>
								</footer>
								<footer class="mdc-dialog__footer" v-if="changeDomainComplete">
									<button type="button" @click.prevent="ownDomainDialog = false; changeDomainComplete = false; changeDomainSuccess = null;" class="mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel mdc-ripple-upgraded">CLOSE</button>
								</footer>
								</div>
								<div class="mdc-dialog__backdrop" @click.prevent="ownDomainDialog = false"></div>
							</aside>

							<!-- New domain dialog -->
							<aside id="own-domain-dialog" class="mdc-dialog website-edit__custom-domain-dialog text-left" :class="{'mdc-dialog--open': newDomainDialog}" role="alertdialog" aria-hidden="true" aria-labelledby="mdc-dialog-default-label" aria-describedby="mdc-dialog-default-description">
								<div class="mdc-dialog__surface">
								<header class="mdc-dialog__header mdc-layout-grid__inner">
								</header>
								<section class="mdc-dialog__body mdc-layout-grid__inner" :class="{'mdc-dialog__body--scrollable': domainAvailable}">
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 website-edit__custom-domain-cell">
										<h3 class="mdc-dialog__header__title" v-if="!buyDomainSuccess">Type a domain name</h3>
										<h3 class="mdc-dialog__header__title success-message" v-if="buyDomainSuccess">Done!</h3>
										<div class="width-100 mdc-textfield mdc-textfield--upgraded">
											<input class="mdc-textfield__input" type="text" v-model="newBuyDomain">
											<span class="input--spinner btn--spinner" :class="{'btn-spin--visible': domainSpinner}"></span>
										</div>
										<div v-if="domainError" class="width-100 mdc-textfield mdc-textfield--upgraded">
											Domain names can contain letters, digits, hyphen, and can not be empty or longer than 63 characters.
										</div>
										<div v-if="domainAvailable === true" class="width-100">
											<!-- BUY DOMAIN -->
											<div class="width-100" v-if="!buyDomainComplete">
												<span class="website-edit__custom-domain--bold">{{newBuyDomain}}</span> is available! It costs £25.00 plus vat for 1 year. You can buy this domain right now for your new website with one click below. We will invoice you for it as soon as it's set up. Once you have bought it, it will be available and live to use for your website usually within one hour. You won't have to do anything else, it's all taken care of automatically.
											</div>
											<div class="width-100 margin-top-30" v-if="buyDomainComplete">
												<div v-if="buyDomainSuccess">
													<h3>Thank you, as soon as your domain is approved we'll change the domain of your website to <span class="website-edit__custom-domain--bold">{{website.siteUrl}}</span>.</h3>
												</div>
												<div v-if="!buyDomainSuccess">
													<h3>Sorry, an error ocurred while registering your domain.</h3>
												</div>
											</div>
										</div>
										<div v-if="domainAvailable === false" class="width-100">
											<!-- AGENT DOMAIN -->
											<p>Domain is not available to buy.</p>
										</div>
									</div>
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-5 website-edit__custom-domain-cell">
											<h3 class="mdc-dialog__header__title">You'll pay</h3>
											<div class="width-100 mdc-textfield mdc-textfield--upgraded">
												<span class="website-edit__custom-domain__price">25£/year</span>
											</div>
									</div>
								</section>
								<footer class="mdc-dialog__footer" v-if="!buyDomainComplete">
									<button type="button" @click.prevent="newDomainDialog = false" class="mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel mdc-ripple-upgraded">CANCEL</button>
									<button-with-spinner :isSaving="isBuyingDomain" :text="isBuyingDomain ? 'Registering domain...' : 'BUY DOMAIN'" :customMethod="buyDomain" :disabled="isBuyingDomain"></button-with-spinner>
								</footer>
								<footer class="mdc-dialog__footer" v-if="buyDomainComplete">
									<button type="button" @click.prevent="newDomainDialog = false; buyDomainComplete = false; buyDomainSuccess = null;" class="mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel mdc-ripple-upgraded">CLOSE</button>
								</footer>
								</div>
								<div class="mdc-dialog__backdrop" @click.prevent="newDomainDialog = false"></div>
							</aside>

						</div>

						<!-- Default Homepage Search -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Default Homepage Search</span></div>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<div class="mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth mdc-text-field--upgraded">
									<button class="btn btn--bordered" :class="{'btn--selected': website.defaultServiceType == 'sales'}" @click="website.defaultServiceType = 'sales'" style="display: inline-block;">Sales</button>
									<button class="btn btn--bordered" :class="{'btn--selected': website.defaultServiceType == 'lettings'}" @click="website.defaultServiceType = 'lettings'" style="display: inline-block">Lettings</button>
								</div>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Default Price Order -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Default Price Order</span></div>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<div class="mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth mdc-text-field--upgraded">
									<button class="btn btn--bordered" :class="{'btn--selected': website.defaultPriceOrder == 'lowtohigh'}" @click="website.defaultPriceOrder = 'lowtohigh'" style="display: inline-block;">Low to High</button>
									<button class="btn btn--bordered" :class="{'btn--selected': website.defaultPriceOrder == 'hightolow'}" @click="website.defaultPriceOrder = 'hightolow'" style="display: inline-block">High to Low</button>
								</div>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- About us Text -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>About us</span></div>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<div class="mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth mdc-text-field--upgraded">
									<textarea class="mdc-text-field__input width-100 description-textarea" v-model="website.aboutUs.about" placeholder="About Us (No limit. Go wild!)" rows="8"></textarea>
								</div>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Address -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Address</span></div>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<google-places-input v-on:googlePlacesUpdated="googlePlacesUpdated" placeholder="Type '28 Street name'" v-model="website.contacts.address"></google-places-input>
								Branch Address: {{website.contacts.address}}
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Email -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Email</span></div>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<input class="mdc-textfield__input" type="email" v-model="website.contacts.email" placeholder="" v-validate="'required: true'" name="Email">
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Phone Number -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Phone Number</span></div>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<input class="mdc-textfield__input" type="tel" v-model="website.contacts.phoneNumber" placeholder="" v-validate="'required: true'" name="Phone Number" inputmode="numeric" pattern="[0-9]*">
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- About Us photo -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Upload your team photo</span></div>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<s3 key="s3-images" v-model="website.aboutUs.images" :single="true" @uploading="isUploading = arguments[0]"></s3>

								<div v-if="website.aboutUs.images" class="s3__image-grid">
									<div class="s3__image" :style="{backgroundImage: 'url(\'' + s3url(website.aboutUs.images, 'small') + '\')'}">
										<span class="editable-photos__remove-btn" @click="removeImage()"><i class="ico ico-delete"></i></span>
									</div>
								</div>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Logo -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Upload your Logo</span></div>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<s3 key="s3-images" v-model="website.logo" :single="true" @complete="logoUploaded = true" @uploading="isUploading = arguments[0]"></s3>
								<div v-if="logoUploaded || website.logo" class="s3__image-grid">
									<div class="s3__image" :style="{backgroundImage: 'url(\'' + s3url(website.logo, 'small') + '\')'}">
										<span class="editable-photos__remove-btn" @click="removeLogo()"><i class="ico ico-delete"></i></span>
									</div>
								</div>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Social -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Social Media Accounts</span></div>
							</div>
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<input-with-clear v-model="website.socialMedia.facebook" :placeholder="'Facebook'"></input-with-clear>
								<input-with-clear v-model="website.socialMedia.instagram" :placeholder="'Instagram'"></input-with-clear>
								<input-with-clear v-model="website.socialMedia.linkedIn" :placeholder="'LinkedIn'"></input-with-clear>
								<input-with-clear v-model="website.socialMedia.twitter" :placeholder="'Twitter'"></input-with-clear>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Redress Scheme -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Property Redress Scheme</span></div>
							</div>
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<div class="mdc-layout-grid mdc-layout-grid__inner">
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-form-field" v-for="item in redressSchemeList">
										<div class="mdc-checkbox">
											<input :id="item.id" :value="item.id" class="mdc-checkbox__native-control" type="checkbox" v-model="website.redressScheme">
											<div class="mdc-checkbox__background"></div>
										</div>
										<label :for="item.id">{{ item.name }}</label>
									</div>
								</div>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Body Membership -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Professional Body Membership</span></div>
							</div>
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<div class="mdc-layout-grid mdc-layout-grid__inner">
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-form-field" v-for="item in bodyMembershipList">
										<div class="mdc-checkbox">
											<input :id="item.id" :value="item.id" class="mdc-checkbox__native-control" type="checkbox" v-model="website.bodyMembership">
											<div class="mdc-checkbox__background"></div>
										</div>
										<label :for="item.id">{{ item.name }}</label>
									</div>
								</div>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Portals -->
						<div class="editable-item mdc-layout-grid__inner">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Portals</span></div>
							</div>
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<div class="mdc-layout-grid mdc-layout-grid__inner">
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-form-field" v-for="item in portalsList">
										<div class="mdc-checkbox">
											<input :id="item.id" :value="item.id" class="mdc-checkbox__native-control" type="checkbox" v-model="website.portals">
											<div class="mdc-checkbox__background"></div>
										</div>
										<label :for="item.id">{{ item.name }}</label>
									</div>
								</div>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Tenant Fees -->
						<div class="mdc-layout-grid__inner" v-if="website.serviceType != 'Sales'">

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
								<div class="editable-item__centered"><span>Tenants Fees</span></div>
							</div>
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
								<div class="mdc-layout-grid mdc-layout-grid__inner mdc-layout-grid__cell--span-4">
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 mdc-form-field">
									 <p>VAT registered:</p>
										<button class="btn btn--bordered" :class="{'btn--selected': vatRegistered === true}" v-on:click="vatRegistered = true" style="display: inline-block; margin-left: 50px">Yes</button>
										<button class="btn btn--bordered" :class="{'btn--selected': vatRegistered === false}" v-on:click="vatRegistered = false" style="display: inline-block">No</button>
									</div>
								</div>
							</div>
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 mdc-form-field">
								<tenant-fee v-model="website.tenantFees" :vatRegistered="vatRegistered"></tenant-fee>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>

						<!-- Save website -->
					<div class="editable-item mdc-layout-grid__inner">
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 editable-item__title">
							<button-with-spinner :isSaving="isSaving" :text="isSaving ? 'Updating website...' : 'Save Website'" :customMethod="updateWebsite" :disabled="isSaving"></button-with-spinner>
							<!-- <p style="display:inline-block; width: 100%"><a style="float: right" href="/settings/tenant-fees" target="_blank">Tenant Fees Set Up</a></p> -->
						</div>
					</div>
				</div>
			</div>
		</div>

			<!-- Photos Slideshow -->
				<!-- <slider id="slider-modal" v-model="property.images"></slider> -->
		</div>


	</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import ButtonWithSpinner  from '../components/ButtonWithSpinner.vue';
import GooglePlacesInput  from '../components/GooglePlacesInput.vue';
import AddressInput      from '../components/AddressInput.vue';
import S3                 from '../components/S3.vue';
import InputWithClear from '../components/InputWithClear.vue';
import Vue                from 'vue';
import VeeValidate       from 'vee-validate';
import EditableItem 	from '../components/editable-items/EditableItem.vue';
import SocialShare from '../components/SocialShare.vue';
import TenantFee from '../components/TenantFee.vue';
Vue.use(VeeValidate);

export default {
	data: function() {
		return {
			loaded: false,
			vatRegistered: false,
			website: {
				socialMedia: {
					facebook: '',
					twitter: '',
					instagram: '',
					linkedIn: ''
				},
				redressScheme: [],
				bodyMembership: [],
				portals: [],
				tenantFees: [],
				vatRegistered: false,
				defaultServiceType: 'sales',
				defaultPriceOrder: 'lowtohigh',
				//apagar
				aboutUs: {
					about: ''
				},
				//apagar
				contacts: {
					address: ''
				}
			},
			contact: {
				email: ''
			},
			isSaving: false,
			imageUploaded: false,
			isUploading: false,
			websiteLoaded: false,
			logoUploaded: false,
			scroll: false,
			windowWidth: 0,
			windowHeight: 0,
			responsive: false,
			redressSchemeList: [
				{ id: 'the-property-ombudsman', name: 'The Property Ombudsman' },
				{ id: 'ombudsman-services', name: 'Ombudsman Services' },
				{ id: 'property-redress-scheme', name: 'Property Redress Scheme' }
			],
			bodyMembershipList: [
				{ id: 'NAEA', name: 'NAEA' },
				{ id: 'ARLA', name: 'ARLA' },
				{ id: 'RICS', name: 'RICS' }
			],
			portalsList: [
				{ id: 'rightmove', name: 'Rightmove' },
				{ id: 'zoopla', name: 'Zoopla' },
				{ id: 'onthemarket', name: 'OnTheMarket' }
			],
			newChangeDomain: '',
			newBuyDomain: '',
			domainSpinner: false,
			domainTimeout: null,
			domainAvailable: null,
			domainError: false,
			isBuyingDomain: false,
			buyDomainComplete: false,
			buyDomainSuccess: null,
			ownDomainDialog: false,
			newDomainDialog: false,
			isChangingDomain: false,
			changeDomainComplete: false,
			changeDomainSuccess: null
		}
	},
	mixins: [utils],
	computed: {
	},
	components: {
		'editable-item': EditableItem,
		'button-with-spinner': ButtonWithSpinner,
		'google-places-input': GooglePlacesInput,
		'address-input': AddressInput,
		'input-with-clear': InputWithClear,
		's3': S3,
		'social-share': SocialShare,
		'tenant-fee': TenantFee
	},
	mounted: async function(){
		const website = await api({endpoint: this.config.services.website, path: '/get-site', method: 'GET'});

		if(!website.response.Item.defaultServiceType) {
			website.response.Item.defaultServiceType = 'sales';
		}

		if(!website.response.Item.defaultPriceOrder) {
			website.response.Item.defaultPriceOrder = 'lowtohigh';
		}

		if(website.response.Item){
			this.website = website.response.Item;
			if(website.response.Item.aboutUs.images){
				this.website.aboutUs.images = website.response.Item.aboutUs.images;
			}else{
				this.website.aboutUs.images = '';
			}

			if(website.response.Item.logo){
				this.website.logo = website.response.Item.logo;
			}else{
				this.website.logo = '';
			}

			if(website.response.Item.socialMedia.facebook || website.response.Item.socialMedia.instagram || website.response.Item.socialMedia.linkedIn || website.response.Item.socialMedia.twitter){
				this.website.socialMedia.facebook = website.response.Item.socialMedia.facebook;
				this.website.socialMedia.instagram = website.response.Item.socialMedia.instagram;
				this.website.socialMedia.linkedIn = website.response.Item.socialMedia.linkedIn;
				this.website.socialMedia.twitter = website.response.Item.socialMedia.twitter;
			}else{
				this.website.socialMedia.facebook = '';
				this.website.socialMedia.instagram = '';
				this.website.socialMedia.linkedIn = '';
				this.website.socialMedia.twitter = '';
			}

			this.website.redressScheme = this.website.redressScheme ? this.website.redressScheme : [];
			this.website.bodyMembership = this.website.bodyMembership ? this.website.bodyMembership : [];
			this.website.portals = this.website.portals ? this.website.portals : [];
			this.website.tenantFees = this.website.tenantFees ? this.website.tenantFees : [];
			this.vatRegistered = this.website.vatRegistered ? this.vatRegistered : false;

			if(this.website.siteUrl.indexOf('http') == -1) {
				this.website.siteUrl = 'http://' + this.website.siteUrl;
			}
		}

		const company = await api({endpoint: this.config.services.companyDetails, path:'/', method: 'GET'});
		this.website.company = {
			name : company.companyDetails.companyName,
			email : company.companyDetails.email,
			registrationName : company.companyDetails.registrationName,
			registrationNumber : company.companyDetails.registrationNumber,
			address: {
				buildingNumber : company.companyDetails.registrationAddress.buildingNumber,
				street : company.companyDetails.registrationAddress.street,
				// county : company.companyDetails.registrationAddress.county ? county : '',
				postCode : company.companyDetails.registrationAddress.postcode,
				town : company.companyDetails.registrationAddress.town
			},
			serviceType: company.companyDetails.serviceType
		};
		this.website.defaultServiceType = website.response.Item.defaultServiceType ? website.response.Item.defaultServiceType : company.companyDetails.serviceType != 'both' ? company.companyDetails.serviceType : 'sales';
		this.website.defaultPriceOrder = website.response.Item.defaultPriceOrder ? website.response.Item.defaultPriceOrder : 'lowtohigh';

		this.website.footerContents = this.footerContents;

		this.loaded = true;
	},
	watch: {
		newBuyDomain: function() {
			if(!this.domainSpinner) {
				this.domainSpinner = true;
			}
			clearTimeout(this.domainTimeout);
			this.domainError = false;
			this.domainAvailable = null;
			const that = this;
			this.domainTimeout = setTimeout(async function() {
				try {
					const response = await api({endpoint: that.config.services.domains, path: '/check', method: 'POST', body: {domain: that.newBuyDomain}});
					that.domainSpinner = false;
					if(response.available) {
						that.domainAvailable = true;
					} else {
						that.domainAvailable = false;
					}
				} catch(err) {
					that.domainSpinner = false;
					that.domainError = true;
					console.error('Error checking domain:', err);
				}
			}, 1000);
		}
	},
	methods: {
		updateWebsite: async function() {
			this.isSaving = true;
			try {
				this.website.vatRegistered = this.vatRegistered;
				const response = await api({endpoint: this.config.services.website, path: '/update-site', method: 'POST', body: this.website});
			} catch(err) {
				alert('Sorry, something went wrong...');
				console.error('Error creating site:', err);
			}
			this.isSaving = false;
		},
		googlePlacesUpdated: function(place) {
			if (place.street == '' || place.postcode == '') {
				return;
			}
			this.website.contacts.address = place.buildingNumber + " " + place.street + ", " + place.town + "  " + place.postcode
		},
		setDefaultAddress: function(value) {
			this.defaultAddress = value;
			this.website.contacts.address = value;
		},
		removeImage: function() {
			if (confirm('Are you sure you want to delete this photo?')) {
				this.website.aboutUs.images = '';
			}
		},
		removeLogo: function() {
			if (confirm('Are you sure you want to delete this logo?')) {
				this.website.logo = '';
				this.logoUploaded = false;
			}
		},
		updateSiteDetails: async function() {
			var result = await api({endpoint: this.config.services.website, path: '/' + this.$route.params.id, method: 'PUT', body: this.website});
		},
		buyDomain: async function() {
			if(confirm(`Are you sure you want to buy the domain ${this.newBuyDomain}?`)) {
				this.isBuyingDomain = true;
				try {
					const response = await api({endpoint: this.config.services.domains, path: '/register', method: 'POST', body: {domain: this.newBuyDomain}});
					this.website.siteUrl = this.checkUrl(this.newBuyDomain);
					this.isBuyingDomain = false;
					this.buyDomainComplete = true;
					this.buyDomainSuccess = true;
					console.log(this.buyDomainComplete);
				} catch(err) {
					console.error('Error registering domain:', err);
					this.isBuyingDomain = false;
					this.buyDomainComplete = true;
					this.buyDomainSuccess = false;
				}
			}
		},
		changeDomain: async function() {
			this.isChangingDomain = true;
			try {
				const response = await api({endpoint: this.config.services.domains, path: '/change', method: 'POST', body: {domain: this.newChangeDomain}});
				this.website.siteUrl = this.checkUrl(this.newChangeDomain);
				this.isChangingDomain = false;
				this.changeDomainComplete = true;
				this.changeDomainSuccess = true;
			} catch(err) {
				console.error('Error changing domain:', err);
				this.isChangingDomain = false;
				this.changeDomainComplete = true;
				this.changeDomainSuccess = false;
			}
		},
		checkUrl: function(url) {
			if(url.indexOf('http') == -1) {
				return 'http://' + url;
			} else {
				return url;
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Website-Edit.vue